import { gql } from "@apollo/client";

export const DELETE_INVOICE_UPLOAD_UNIT = gql`
  mutation deleteInvoiceUploadUnit($input: DeleteUploadUnitInput!) {
    documentHandler {
      deleteInvoiceUploadUnit(input: $input) {
        success
      }
    }
  }
`;
